import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Lots_ds_get_lot_by_lookupcode_materialId_and_vendor_lookupcodeService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialId: number, lotLookupcode: string, vendorLookupcode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLotId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.lotLookupcode)) {
      missingRequiredInParams.push('\'lotLookupcode\'');
    }
    if (isNil(inParams.vendorLookupcode)) {
      missingRequiredInParams.push('\'vendorLookupcode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/datasources/ds_get_lot_by_lookupcode_materialId_and_vendor_lookupcode/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { materialId: number, lotLookupcode: string, vendorLookupcode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLotId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.lotLookupcode)) {
      missingRequiredInParams.push('\'lotLookupcode\'');
    }
    if (isNil(inParams.vendorLookupcode)) {
      missingRequiredInParams.push('\'vendorLookupcode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/datasources/ds_get_lot_by_lookupcode_materialId_and_vendor_lookupcode/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { materialId: number, lotLookupcode: string, vendorLookupcode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLotId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.lotLookupcode)) {
      missingRequiredInParams.push('\'lotLookupcode\'');
    }
    if (isNil(inParams.vendorLookupcode)) {
      missingRequiredInParams.push('\'vendorLookupcode\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/datasources/ds_get_lot_by_lookupcode_materialId_and_vendor_lookupcode/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      materialId: number, lotLookupcode: string, vendorLookupcode: string    }) {
        if(isNil(inParams.materialId)) {
          return true; 
        }
        if(isNil(inParams.lotLookupcode)) {
          return true; 
        }
        if(isNil(inParams.vendorLookupcode)) {
          return true; 
        }
      return false;
    }
}
